import { makeStyles, createStyles, Theme, alpha } from '@maas-components/core';
import shell, { StyleProps } from '../theme';

const styles = (theme: Theme) => {
    return createStyles({
        root: {
            backgroundColor: theme.palette.background.paper,
        },

        small: {
            width: theme.spacing(5),
            height: theme.spacing(5),
        },

        icon: {
            width: theme.spacing(4),
            height: theme.spacing(4),
        },

        listItemTextSecondary: {
            display: 'flex',
            flexDirection: 'column',
        },

        paper: { width: 320 },
        paperMobile: { minWidth: '100%', borderRadius: 0 },
        sellerBadge: {
            '& > [class*="MuiBadge-badge"]': {
                padding: 0,
            },
        },
        avatar: {
            backgroundColor: (props: StyleProps) => shell[props.mode].profile.avatar.background,
            width: theme.spacing(5),
            height: theme.spacing(5),
        },
        avatarUserInfo: {
            backgroundColor: theme.palette.grey[600],
            width: theme.spacing(5),
            height: theme.spacing(5),
        },
        sellerAvatarBadge: {
            width: theme.spacing(3),
            height: theme.spacing(3),
            backgroundColor: theme.palette.primary.main,
            fontSize: 14,
            border: `2px solid ${theme.palette.common.white}`,
        },
        sellerAvatar: {
            backgroundColor: theme.palette.grey[500],
        },
        selectedSellerAvatar: {
            backgroundColor: theme.palette.primary.main,
        },
        selectedIcon: {
            color: theme.palette.success.main,
        },
        listItem: {
            padding: theme.spacing(1, 6, 1, 3),
        },
        avatarListItem: {
            padding: theme.spacing(1, 3, 1, 3),
        },
        listItemTitle: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '@supports (-webkit-line-clamp: 2)': {
                lineClamp: 2,
                display: '-webkit-box',
                '-webkit-box-orient': 'vertical',
            },
        },
        selectedListItem: {
            backgroundColor: alpha(theme.palette.primary.light, 0.1),
        },
        logoutListItem: {
            padding: theme.spacing(1, 6, 1, 3),
            marginTop: theme.spacing(1),
            '& svg': {
                marginRight: theme.spacing(1.5),
            },
        },
        closeButton: {
            position: 'absolute',
            right: 0,
            zIndex: theme.zIndex.modal + 1,
        },
        companyName: {
            lineHeight: '1rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'left',
            color: (props: StyleProps) => shell[props.mode].profile.companyName,
            width: 150,
        },
        userInfo: {
            lineHeight: '1rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'left',
            color: (props: StyleProps) => shell[props.mode].profile.userName,
            width: 150,
        },
        profileButton: {
            borderRadius: theme.spacing(1),
        },
    });
};

export default makeStyles(styles, { name: 'MuiShellProfile' });
